/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import {Table , Row , Col} from 'react-bootstrap';
import FieldGroup from '../FieldGroup.js';
import validator from 'validator';
import Alert from '../alert.js';
import {AccountService , InternationalizationService} from '../../services';
import {Translation, AccountStore} from '../../store';
import Constants from '../../constants.js';

export default class Establishment extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            countries:Translation.getCountriesList(),
            loaded:true
        };
    }

    renderPanelHeader(){
        return <div>
            <h1>{Translation.get(12654 , 'Import Students')}</h1>
        </div>
    }

    save(){
        AccountService.update({
            name:this.state.name,
            billing_address_street:this.state.billing_address_street,
            billing_address_postalcode:this.state.billing_address_postalcode,
            general_enquiry_email:this.state.general_enquiry_email,
            general_enquiry_phone:this.state.general_enquiry_phone,
            billing_address_country:this.state.billing_address_country,
            referance:this.state.referance
        }).then(function(){
            this.setState({
                saved:true,
                baseEmail:this.state.email,
            });
        }.bind(this))
    }

    componentDidMount(){
        AccountService.getInformation();
        if(Translation.getCountriesList().length == 0) InternationalizationService.getCountries();
    }

    componentWillMount(){
        Translation.on(Constants.GET_COUNTRIES , ()=>{

            this.setState({
                countries:Translation.getCountriesList()
            });
        })

        AccountStore.on(Constants.GET_ACCOUNT , ()=>{
            console.log(AccountStore.get())
            this.setState({
                loaded:true,
                "name": AccountStore.get().name,
                "billing_address_street" : AccountStore.get().billing_address_street,
                "billing_address_postalcode" : AccountStore.get().billing_address_postalcode,
                "general_enquiry_email":AccountStore.get().general_enquiry_email,
                "general_enquiry_phone":AccountStore.get().general_enquiry_phone,
                "billing_address_country":AccountStore.get().billing_address_country,
                "referance":AccountStore.get().referance,
            });
        })
    }

    validate(id){

        switch(id)
        {
            case "name": return !validator.isEmpty(String(this.state.name));
            case "billing_address_street": return !validator.isEmpty(String(this.state.billing_address_street));
            case "billing_address_postalcode": return !validator.isEmpty(String(this.state.billing_address_postalcode));
            case "general_enquiry_email": return validator.isEmail(String(this.state.general_enquiry_email))
            case "general_enquiry_phone": return !validator.isEmpty(String(this.state.general_enquiry_phone));
        }

        return true;
    }

    render() {

        let options = [];

        for(var idx = 0 ; idx < this.state.countries.length; idx++)
        {
            options.push(<option value={this.state.countries[idx].country_code} >{this.state.countries[idx].country_name}</option>);
        }

        let saved = null;

        if(!this.state.loaded) return <div style={{minHeight:"400px"}} className="fast animated fadeIn "></div>;
        if(this.state.saved){
            saved = <Alert  variant="success">{Translation.get(12655 , 'Your information has been updated')}</Alert>;
        }

        return <div>
                {saved}
            <Row>
                <Col md={6}>
                    <FieldGroup value={this.state.name} state={!this.validate('name') ? "invalid" : ""} help={!this.validate('name') ? Translation.get(12782, "This can't be blank") : ""}  id="student-name" onChange={(event)=>{this.setState({saved:false, name:event.target.value})}} label="School Learning Languages"/>
                </Col>
                <Col md={6}>
                    <FieldGroup value={this.state.name} state={!this.validate('name') ? "invalid" : ""} help={!this.validate('name') ? Translation.get(12782, "This can't be blank") : ""}  id="student-name" onChange={(event)=>{this.setState({saved:false, name:event.target.value})}} label="School Interface Languages"/>
                </Col>
            </Row>
            <hr/>
            <b>
                <h5>Customized Grading</h5>
                <small>These settings let you customize grading bonders and scores and reports<a class="hyperlink" herf="#" > see viedo</a></small>
            </b>
            <br/>
            <br/>
            <Table size="sm"  bordered={false}  responsive>
                <tr><td><div style={{marginTop:"5px"}}><b>90% - 100%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>80% - 90%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>70% - 80%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>60% - 70%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>50% - 60%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>40% - 50%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>30% - 40%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>20% - 30%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>10% - 20%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>
                <tr><td><div style={{marginTop:"5px"}}><b>0% - 10%</b></div></td><td><input style={{width:'100%' , padding:"5px"}}/></td></tr>

            </Table>
        </div>;
    }

}